import * as React from 'react';
import { addImageParams, logoUrl } from '@/utils/urls';
import { getBaseUrl } from '@/redux/modules/config';
import { getItemFirstImageUrl } from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

type Props = {
    collectionId: number;
    collectionLabel: string;
    collectionName: string;
    itemId: number;
};

const CuratedCollectionPageHeaderMeta = ({ collectionId, collectionLabel, collectionName, itemId }: Props) => {
    const baseUrl = useAppSelector(getBaseUrl);
    const { formatMessage } = useIntl();
    const firstPhoto = useAppSelector((state) => getItemFirstImageUrl(state, itemId));
    const imageUrl = addImageParams({ url: firstPhoto, width: 512 });

    return (
        <PageHeaderMeta
            canonical={`${baseUrl}/featured/${collectionName}/${collectionId}`}
            description={formatMessage({ id: 'collection.title' }, { collectionLabel })}
            imageUrl={imageUrl || logoUrl}
            title={useAddNotificationCountToTitle(formatMessage({ id: 'collection.title' }, { collectionLabel }))}
        />
    );
};

export default React.memo<Props>(CuratedCollectionPageHeaderMeta);
